import { Observable } from 'rxjs';


export interface MenuTemplate
{
    id: number,
    price: number,
    details: MenuTemplateDetail[],
    categories: DishCategory[],
    allergens: DishAllergens[]
}

export interface MenuTemplateDetail
{
    languageId: number,
    language: string,
    title: string,
    description: string,
    imageUrl: string,
    ingredients: string[],
    parts: string[]
}

export interface DishCategory
{
    id: number,
    languageId: number,
    language: string,
    name: string
}

export interface DishAllergens
{
    id: number,
    languageId: number,
    language: string,
    name: string
}

export interface MenuEntry
{
    menuStartDate: Date,
    menuEndDate: Date,
    entries: MenuEntrySummary[]
}

export interface MenuEntrySummary
{
    id: number,
    price: number,
    placedOrdersCount: number,
    completedOrdersCount: number,
    totalValue: number,
    dishOfTheDay: Date | null,
    details: MenuEntrySummaryDetails[],
    categories: DishCategory[],
    allergens: DishAllergens[],
    isHidden: boolean
}

export interface MenuEntrySummaryDetails
{
    languageId: number,
    language: string,
    title: string,
    description: string,
    imageUrl: string,
    ingredients: string[],
    parts: string[]
}

export abstract class MenuTemplatesData {
    abstract getAllMenuTemplates(): Observable<MenuTemplate[]>;
    abstract getAllDishCategories(): Observable<DishCategory[]>;
    abstract getAllAllergens(): Observable<DishAllergens[]>;
}



export abstract class MenuEntriesData {
    abstract getMenuEntryForDate(startDay: Date): Observable<MenuEntry>;
}